import { createRouter, createWebHistory } from 'vue-router'
import { ElNotification, ElMessage } from 'element-plus'

import Layout from '@/views/layout/index.vue'

import { start, close } from '@/utils/nprogress.js'
import { WEBSITE_TI } from '@/config/constant.js'

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    component: Layout,
    children: [
      {
        path: '',
        name: 'Home',
        meta: {
          title: '首页'
        },
        component: () =>
          import(/* webpackChunkName: "main" */ '@/views/home/index.vue')
      }
    ]
  },
  // ISTEM结果
  {
    path: '/ISTEM',
    redirect: '/ISTEM/hospital',
    component: Layout,
    children: [
      {
        path: ':type',
        name: 'ISTEM',
        meta: {
          title: 'ISTEM结果'
        },
        component: () =>
          import(/* webpackChunkName: "ISTEM" */ '@/views/istem/index.vue')
      }
    ]
  },
  // {
  //   path: '/techV',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'hospital',
  //       name: 'TechVHospital',
  //       meta: {
  //         title: '医院科技量值',
  //         type: 'hospital'
  //       },
  //       component: () =>
  //         import(/* webpackChunkName: "techV" */ '@/views/tech-v/index.vue')
  //     },
  //     {
  //       path: 'university',
  //       name: 'TechVuniversity"',
  //       meta: {
  //         title: '医学院校科技量值',
  //         type: 'university'
  //       },
  //       component: () =>
  //         import(/* webpackChunkName: "techV" */ '@/views/tech-v/index.vue')
  //     }
  //   ]
  // },
  // STEM结果
  {
    path: '/result',
    redirect: '/result/hospital',
    component: Layout,
    children: [
      {
        path: ':type', //医院STEM、医学院校STEM
        name: 'Result',
        meta: {
          title: 'STEM结果'
        },
        component: () =>
          import(/* webpackChunkName: "result" */ '@/views/result/index.vue')
      }
    ]
  },
  // ASTEM结果
  {
    path: '/ASTEM',
    redirect: '/ASTEM/hospital',
    component: Layout,
    children: [
      {
        path: ':type', //医院ASTEM、医学院校ASTEM
        name: 'ASTEM',
        meta: {
          title: 'ASTEM结果'
        },
        component: () =>
          import(/* webpackChunkName: "ASTEM" */ '@/views/astem/index.vue')
      }
    ]
  },
  //新闻纵览
  {
    path: '/news',
    component: Layout,
    children: [
      {
        path: '',
        name: 'News',
        meta: {
          title: '新闻纵览'
        },
        component: () =>
          import(/* webpackChunkName: "news" */ '@/views/news/index.vue')
      },
      {
        path: ':id',
        name: 'NewsDetail',
        meta: {
          title: '新闻详情'
        },
        component: () =>
          import(/* webpackChunkName: "news" */ '@/views/news/detail/index.vue')
      }
    ]
  },
  {
    path: '/moment',
    component: Layout,
    children: [
      {
        path: '',
        name: 'Moment',
        meta: {
          title: '精彩瞬间'
        },
        component: () =>
          import(/* webpackChunkName: "moment" */ '@/views/moment/index.vue')
      },
      {
        path: ':year/photoAlbum',
        name: 'PhotoAlbum',
        meta: {
          title: '图片集 - 精彩瞬间'
        },
        component: () =>
          import(
            /* webpackChunkName: "moment" */ '@/views/moment/album/photo.vue'
          )
      },
      {
        path: ':year/video',
        name: 'VideoAlbum',
        meta: {
          title: '视频回放 - 精彩瞬间'
        },
        component: () =>
          import(
            /* webpackChunkName: "moment" */ '@/views/moment/album/video.vue'
          )
      }
    ]
  },
  //评价方法
  {
    path: '/evaluation',
    component: Layout,
    children: [
      {
        path: '',
        name: 'Evaluation',
        meta: {
          title: '评价方法'
        },
        component: () =>
          import(
            /* webpackChunkName: "evaluation" */ '@/views/evaluation/index.vue'
          )
      }
    ]
  },
  //业务范围
  {
    path: '/business',
    name: 'Business',
    component: Layout,
    children: [
      {
        path: '',
        meta: {
          title: '业务范围'
        },
        component: () =>
          import(
            /* webpackChunkName: "business" */ '@/views/business/index.vue'
          )
      }
    ]
  },
  //联系我们
  {
    path: '/contact',
    name: 'Contact',
    component: Layout,
    children: [
      {
        path: '',
        meta: {
          title: '联系我们'
        },
        component: () =>
          import(/* webpackChunkName: "main" */ '@/views/contact/index.vue')
      }
    ]
  },
  {
    path: '/serverError',
    name: '500',
    meta: {
      title: '服务器错误'
    },
    component: () => import('@/views/errors/500.vue')
  },
  {
    path: '/:error*',
    name: '404',
    meta: {
      title: '404'
    },
    component: () => import('@/views/errors/404.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0, behavior: 'smooth' }
  }
})

router.beforeEach((to, from, next) => {
  start()
  // 设置浏览器标题
  if (to.meta.title) {
    document.title = `${String(to.meta.title)} - ${WEBSITE_TI}`
  } else {
    document.title = WEBSITE_TI
  }
  // 路由出错处理
  if (to.matched.length === 0 && !to.name) {
    ElNotification({
      title: 'Error',
      message: 'This is an error message',
      type: 'error',
      duration: 5000
    })
    ElMessage.error('404')
    router.push('/404')
  }
  next()
})

// 路由加载结束后执行
router.afterEach(() => {
  close()
})

export default router
